module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column px-4 py-4",
    staticStyle: {
      "max-width": "inherit",
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row mx-0"
  }, [_c('Select', {
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "v": _vm.$v.studyPlaceComputed.education_type,
      "label": "ТИП ОБРАЗОВАНИЯ",
      "placeholder": "Выберите тип образования",
      "options": _vm.educationTypeDict,
      "required": "required"
    },
    model: {
      value: (_vm.studyPlaceComputed.education_type),
      callback: function($$v) {
        _vm.$set(_vm.studyPlaceComputed, "education_type", $$v)
      },
      expression: "studyPlaceComputed.education_type"
    }
  }), _c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.excludeForAdditional.includes(_vm.studyPlaceComputed.education_type)),
      expression: "!excludeForAdditional.includes(studyPlaceComputed.education_type)"
    }],
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "label": "УРОВЕНЬ ОБРАЗОВАНИЯ",
      "placeholder": "Выберите уровень образования",
      "disabled": _vm.excludeForAdditional.includes(_vm.studyPlaceComputed.education_type),
      "readonly": _vm.excludeForAdditional.includes(_vm.studyPlaceComputed.education_type),
      "options": _vm.educationLevelDict,
      "v": _vm.$v.studyPlaceComputed.education_level,
      "error-text": _vm.getError(_vm.$v.studyPlaceComputed.education_level),
      "required": "required"
    },
    model: {
      value: (_vm.studyPlaceComputed.education_level),
      callback: function($$v) {
        _vm.$set(_vm.studyPlaceComputed, "education_level", $$v)
      },
      expression: "studyPlaceComputed.education_level"
    }
  }), _c('FormInput', {
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "v": _vm.$v.studyPlaceComputed.study_place,
      "label": "МЕСТО УЧЕБЫ",
      "placeholder": "Введите место учебы",
      "error-text": _vm.getError(_vm.$v.studyPlaceComputed.study_place),
      "required": "required"
    },
    model: {
      value: (_vm.studyPlaceComputed.study_place),
      callback: function($$v) {
        _vm.$set(_vm.studyPlaceComputed, "study_place", $$v)
      },
      expression: "studyPlaceComputed.study_place"
    }
  }), _c('FormInput', {
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "label": "СПЕЦИАЛИЗАЦИЯ",
      "placeholder": "Введите специализацию"
    },
    model: {
      value: (_vm.studyPlaceComputed.specialization),
      callback: function($$v) {
        _vm.$set(_vm.studyPlaceComputed, "specialization", $$v)
      },
      expression: "studyPlaceComputed.specialization"
    }
  }), _c('FormInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.excludeForBasic.includes(_vm.studyPlaceComputed.education_type)),
      expression: "!excludeForBasic.includes(studyPlaceComputed.education_type)"
    }],
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "label": "НАЗВАНИЕ КУРСА, ПРОГРАММЫ, СЕМИНАРА И Т.П.",
      "placeholder": "Введите название"
    },
    model: {
      value: (_vm.studyPlaceComputed.course_name),
      callback: function($$v) {
        _vm.$set(_vm.studyPlaceComputed, "course_name", $$v)
      },
      expression: "studyPlaceComputed.course_name"
    }
  }), _c('FormInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.studyPlaceComputed.is_currently),
      expression: "!studyPlaceComputed.is_currently"
    }],
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "label": "ГОД ОКОНЧАНИЯ",
      "placeholder": "Введите год окончания",
      "v": _vm.$v.studyPlaceComputed.year,
      "error-text": _vm.getError(_vm.$v.studyPlaceComputed.year, {
        field: "Год",
        additional: ("больше 1900 и меньше " + (Number(new Date().getFullYear())))
      }),
      "maxlength": "4"
    },
    on: {
      "blur": function($event) {
        _vm.studyPlaceComputed.is_currently && _vm.$v.studyPlaceComputed.year.$dirty ? _vm.$v.studyPlaceComputed.year.$reset() : null
      }
    },
    model: {
      value: (_vm.studyPlaceComputed.year),
      callback: function($$v) {
        _vm.$set(_vm.studyPlaceComputed, "year", $$v)
      },
      expression: "studyPlaceComputed.year"
    }
  }), (_vm.errors.length) ? _c('div', {
    staticClass: "col-12 px-0 mb-4"
  }, _vm._l((_vm.errors), function(error, index) {
    return _c('div', {
      key: index,
      staticClass: "error mb-2 ui_color__red",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(error))])
  }), 0) : _vm._e(), _c('Checkbox', {
    staticClass: "col-12 px-0 mb-4",
    on: {
      "input": function($event) {
        return _vm.resetYear()
      }
    },
    model: {
      value: (_vm.studyPlaceComputed.is_currently),
      callback: function($$v) {
        _vm.$set(_vm.studyPlaceComputed, "is_currently", $$v)
      },
      expression: "studyPlaceComputed.is_currently"
    }
  }, [_vm._v("В настоящее время")]), _c('div', {
    staticClass: "col-md-6 col-12 mb-2 px-0 pe-0 pe-md-2"
  }, [_c('Button', {
    attrs: {
      "disabled": false,
      "isLoading": false
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Сохранить")])], 1), _c('div', {
    staticClass: "col-md-6 col-12 col-6 mb-2 px-0 ps-0 ps-md-2"
  }, [_c('Button', {
    attrs: {
      "alignSelf": "end",
      "bordered": true
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Отменить")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dc1401e","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/study/components/AddEditStudyPlaceBody.vue
// module id = 70519c119e383312a5e7
// module chunks = 29